"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnumManager = createEnumManager;
function createEnumManager(enumMap) {
    const getOptions = () => {
        return Object.entries(enumMap).map(([value, label], index) => ({
            index,
            value,
            label,
        }));
    };
    const getOption = (value) => {
        return getOptions().find(o => o.value === value);
    };
    const getLabel = (value) => {
        return enumMap[value];
    };
    const getValue = (label) => {
        var _a;
        return (_a = getOptions().find(o => o.label === label)) === null || _a === void 0 ? void 0 : _a.value;
    };
    const getValueIndex = (value) => {
        return getOptions().findIndex(o => o.value === value);
    };
    const assertValue = (value) => {
        if (Object.keys(enumMap).includes(value)) {
            return value;
        }
        throw new Error(`${value} is not a valid enum value`);
    };
    return { getOptions, getOption, getLabel, getValue, getValueIndex, assertValue };
}
//# sourceMappingURL=createEnumManager.js.map